namespace SolovisGateway.Admin.EvestmentSync {

    /**
     * JobItemListModel is the backing model for rows in JobsListControl.
     */
    export class JobItemListModel {
        jobKey: string;
        isRegistered: boolean;
        nextRun: string;
        prevRun: string;

        constructor(data?: Partial<JobItemListModel>) {
            if (data) {
                this.jobKey = data.jobKey;
                this.isRegistered = data.isRegistered;
                this.nextRun = data.nextRun;
                this.prevRun = data.prevRun;
            }
        }
    }
}